import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    container: {
        borderRadius: '12.5px',
        backgroundColor: '#fff',
        padding: '2rem',
    },
}));
